import React from 'react'
import { Link } from 'react-router-dom'
import {Form, Button, Row, Col, message} from 'antd';
import { ValidationFormStep1 } from './Step1.js';
import { ValidationFormStep2 } from './Step2.js';
import { ValidationFormStep3 } from './Step3.js';
import { ValidationFormStep4 } from './Step4.js';


class Validation extends React.Component {


    handleSubmit = (e) => {
        e.preventDefault();

        this.props.form.validateFields((err, values) => {
            if (!err) {
                values['currentStepInt'] = this.props.currentStepInt
                values['currentStep'] = this.props.currentStep

                this.props.handleSubmit(values)
            }
        });
    };

    handleNext = (e) => {
        e.preventDefault();

        this.props.form.validateFields((err, values) => {
            if (!err) {
                values['currentStepInt'] = this.props.currentStepInt
                values['currentStep'] = this.props.currentStep

                this.props.handleNext(values)

            } else {
              message.error( 'Please check required inputs');
            }
        });
    };


    previousButton() {
      let {currentStep, currentStepInt} = this.props
      if ( (currentStep === 'Step 2') || (currentStep === 'Step 3')  ) {
        return (
            <Form.Item>
                <Button style={{ color: '#FAFAFA'}} size='large' type="button" loading={this.props.loading} className='btn-submit' onClick={this.props.handlePrev}>
                    Back
                </Button>
            </Form.Item>
        )
      }

      return null;
    }

    nextButton(){
      let {currentStep, currentStepInt} = this.props
      if ( (currentStep === 'Step 1') || (currentStep === 'Step 2') ) {
        return (
            <Form.Item>
                <Button style={{ color: '#FAFAFA'}} size='large' type="button" loading={this.props.loading} className='btn-submit' onClick={this.handleNext}>
                    Next
                </Button>
            </Form.Item>
        )
      } else if (currentStep === 'Step 3')  {
        return (
            <Form.Item>
                <Button style={{ color: '#FAFAFA'}} size='large' type="button" loading={this.props.loading} className='btn-submit' onClick={this.handleNext}>
                    Submit
                </Button>
            </Form.Item>
        )
      }

      return null;
    }



    render() {
        const { getFieldDecorator, getFieldValue } = this.props.form;
        const { loading } = this.props;

        return (
            <Row type='flex' justify='center'>
                <Col xs={24} sm={18} md={18} lg={20} xl={22} className='frosted-card'>
                    <h2> Validate Randomization - {this.props.currentStep}</h2>
                    <Form onSubmit={this.handleSubmit}>

                                          {/*
                                            Step 1 - user enters userID, siteID, subjectID
                                            Step 2 - verifies that userID, siteID are valid, that the subject exists, and if they already have validation data and consent, and asks the user whether the recommended randomization values have been used
                                            Step 3 - user enters validation information
                                            Step 4 - Confirmation of validation process
                                          */}
                                          <ValidationFormStep1
                                            currentStep={this.props.currentStep}
                                            currentStepInt={this.props.currentStepInt}
                                            handleChange={this.props.handleChange}
                                            subjectID={this.props.subjectID}
                                            userID={this.props.userID}
                                            siteID={this.props.siteID}
                                            loading={this.props.loading}
                                            getFieldDecorator={getFieldDecorator}
                                          />
                                          <ValidationFormStep2
                                            currentStep={this.props.currentStep}
                                            currentStepInt={this.props.currentStepInt}
                                            handleChange={this.props.handleChange}
                                            handleVialExpiryDatePickerChange={this.props.handleVialExpiryDatePickerChangeChange}
                                            subjectID={this.props.subjectID}
                                            userID={this.props.userID}
                                            siteID={this.props.siteID}
                                            randomizationDate={this.props.randomizationDate}
                                            randomizationGroup={this.props.randomizationGroup}
                                            randomizationWeight={this.props.randomizationWeight}
                                            randomizationTNKDose={this.props.randomizationTNKDose}
                                            randomizationTPABolusDose={this.props.randomizationTPABolusDose}
                                            randomizationTPAInfusionDose={this.props.randomizationTPAInfusionDose}
                                            consentExists={this.props.consentExists}
                                            validationExists={this.props.validationExists}
                                            validationExistsDate={this.props.validationExistsDate}
                                            validationExistsUsedRecommendedValues={this.props.validationExistsUsedRecommendedValues}
                                            deviationExists={this.props.deviationExists}
                                            validationExistsDeviationOccurred={this.props.validationExistsDeviationOccurred}
                                            validationDeviationExistsComments={this.props.validationDeviationExistsComments}
                                            validationExistsWeight={this.props.validationExistsWeight}
                                            validationExistsGroup={this.props.validationExistsGroup}
                                            validationExistsTNKDose={this.props.validationExistsTNKDose}
                                            validationExistsTPABolusDose={this.props.validationExistsTPABolusDose}
                                            validationExistsTPAInfusionDose={this.props.validationExistsTPAInfusionDose}
                                            validationExistsComments={this.props.validationExistsComments}
                                            validationExistsOptimizeRegistryID={this.props.validationExistsOptimizeRegistryID}
                                            validationExistsVialNumber={this.props.validationExistsVialNumber}
                                            saeExists={this.props.saeExists}
                                            validationExistsVialExpiryDate={this.props.validationExistsVialExpiryDate}
                                            validationExistsVialExpiryDateMoment={this.props.validationExistsVialExpiryDateMoment}
                                            loading={this.props.loading}
                                            getFieldDecorator={getFieldDecorator}
                                          />
                                          <ValidationFormStep3
                                            currentStep={this.props.currentStep}
                                            currentStepInt={this.props.currentStepInt}
                                            handleChange={this.props.handleChange}
                                            handleVialExpiryDatePickerChange={this.props.handleVialExpiryDatePickerChangeChange}
                                            subjectID={this.props.subjectID}
                                            userID={this.props.userID}
                                            siteID={this.props.siteID}
                                            randomizationDate={this.props.randomizationDate}
                                            randomizationGroup={this.props.randomizationGroup}
                                            randomizationWeight={this.props.randomizationWeight}
                                            randomizationTNKDose={this.props.randomizationTNKDose}
                                            randomizationTPABolusDose={this.props.randomizationTPABolusDose}
                                            randomizationTPAInfusionDose={this.props.randomizationTPAInfusionDose}
                                            consentExists={this.props.consentExists}
                                            validationExists={this.props.validationExists}
                                            validationExistsDate={this.props.validationExistsDate}
                                            validationExistsUsedRecommendedValues={this.props.validationExistsUsedRecommendedValues}
                                            deviationExists={this.props.deviationExists}
                                            validationExistsDeviationOccurred={this.props.validationExistsDeviationOccurred}
                                            validationDeviationExistsComments={this.props.validationDeviationExistsComments}
                                            validationExistsWeight={this.props.validationExistsWeight}
                                            validationExistsGroup={this.props.validationExistsGroup}
                                            validationExistsTNKDose={this.props.validationExistsTNKDose}
                                            validationExistsTPABolusDose={this.props.validationExistsTPABolusDose}
                                            validationExistsTPAInfusionDose={this.props.validationExistsTPAInfusionDose}
                                            validationExistsComments={this.props.validationExistsComments}
                                            validationExistsOptimizeRegistryID={this.props.validationExistsOptimizeRegistryID}
                                            validationExistsVialNumber={this.props.validationExistsVialNumber}
                                            validationExistsVialExpiryDate={this.props.validationExistsVialExpiryDate}
                                            validationExistsVialExpiryDateMoment={this.props.validationExistsVialExpiryDateMoment}
                                            submitted={this.props.submitted}
                                            loading={this.props.loading}
                                            getFieldDecorator={getFieldDecorator}
                                            getFieldValue={getFieldValue}
                                          />
                                          <ValidationFormStep4
                                            currentStep={this.props.currentStep}
                                            currentStepInt={this.props.currentStepInt}
                                            handleChange={this.props.handleChange}
                                            subjectID={this.props.subjectID}
                                            userID={this.props.userID}
                                            siteID={this.props.siteID}
                                            randomizationDate={this.props.randomizationDate}
                                            randomizationGroup={this.props.randomizationGroup}
                                            randomizationWeight={this.props.randomizationWeight}
                                            randomizationTNKDose={this.props.randomizationTNKDose}
                                            randomizationTPABolusDose={this.props.randomizationTPABolusDose}
                                            randomizationTPAInfusionDose={this.props.randomizationTPAInfusionDose}
                                            consentExists={this.props.consentExists}
                                            validationExists={this.props.validationExists}
                                            saeExists={this.props.saeExists}
                                            validationExistsDate={this.props.validationExistsDate}
                                            validationExistsUsedRecommendedValues={this.props.validationExistsUsedRecommendedValues}
                                            deviationExists={this.props.deviationExists}
                                            validationExistsDeviationOccurred={this.props.validationExistsDeviationOccurred}
                                            validationDeviationExistsComments={this.props.validationDeviationExistsComments}
                                            validationExistsWeight={this.props.validationExistsWeight}
                                            validationExistsGroup={this.props.validationExistsGroup}
                                            validationExistsTNKDose={this.props.validationExistsTNKDose}
                                            validationExistsTPABolusDose={this.props.validationExistsTPABolusDose}
                                            validationExistsTPAInfusionDose={this.props.validationExistsTPAInfusionDose}
                                            validationExistsComments={this.props.validationExistsComments}
                                            validationExistsOptimizeRegistryID={this.props.validationExistsOptimizeRegistryID}
                                            validationExistsVialNumber={this.props.validationExistsVialNumber}
                                            validationExistsVialExpiryDate={this.props.validationExistsVialExpiryDate}
                                            validationExistsVialExpiryDateMoment={this.props.validationExistsVialExpiryDateMoment}
                                            submitted={this.props.submitted}
                                            loading={this.props.loading}
                                            getFieldDecorator={getFieldDecorator}
                                          />

                                        {this.nextButton()}
                                        {this.previousButton()}


                    </Form>
                      <p>&nbsp;</p>
                      <h5>or select one of the following options:</h5>
                      <ul>
                        <li><Link to='/' style={{ color: '#FAFAFA', width: '12rem' }} className='menu-item'> Home </Link></li>
                      </ul>


                </Col>
            </Row>
        )
    }
}


const ValidationForm = Form.create()(Validation);

export default ValidationForm;



// WEBPACK FOOTER //
// ./src/components/ValidateRandomization/ValidateRandomization.js